import Swal from "sweetalert2";
import Slw from "sweetalert2";

export async function Alert({
  tipo,
  mensagem,
  posicao,
  titulo,
  tempo,
  width,
  textConfirmButton,
  textCancelButton,
  colorCancelButton,
  icon = "info",
}) {
  const temCancelbutton = textCancelButton !== null && textCancelButton !== undefined;
  if (tipo == "Erro") {
    return await Slw.fire({
      title: "Erro",
      html: typeof mensagem == "string" ? mensagem : `${mensagem}`,
      icon: "error",
      iconColor: "#ff0000",
      confirmButtonColor: "var(--azul)",
      confirmButtonText: textConfirmButton || "Confirmar",
    });
  } else if (tipo == "Erro2") {
    return await Slw.fire({
      title: "Erro",
      html: typeof mensagem == "string" ? mensagem : `${mensagem}`,
      icon: "error",
      iconColor: "#ff0000",
      showConfirmButton: false,
      timer: tempo || 2000,
      timerProgressBar: true,
    });
  } else if (tipo == "Sucesso") {
    return await Slw.fire({
      title: "Sucesso",
      html: typeof mensagem == "string" ? mensagem : `${mensagem}`,
      icon: "success",
      iconColor: "#008000",
      confirmButtonColor: "var(--azul)",
      confirmButtonText: textConfirmButton || "Confirmar",
      showCancelButton: temCancelbutton,
      cancelButtonText: textCancelButton || "Cancelar",
      cancelButtonColor: colorCancelButton || "#ff0000",
    });
  } else if (tipo == "Sucesso2") {
    return await Slw.fire({
      title: "Sucesso",
      html: typeof mensagem == "string" ? mensagem : `${mensagem}`,
      icon: "success",
      iconColor: "#008000",
      showConfirmButton: false,
      timer: tempo || 2000,
      timerProgressBar: true,
    });
  } else if (tipo == "Alert") {
    return await Slw.fire({
      title: titulo || "Alerta",
      html: typeof mensagem == "string" ? mensagem : `${mensagem}`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: textCancelButton || "Cancelar",
      cancelButtonColor: "#ff735c",
      iconColor: "#ffae00",
      confirmButtonColor: "var(--azul)",
      confirmButtonText: textConfirmButton || "Confirmar",
    });
  } else if (tipo == "Alert2") {
    return await Slw.fire({
      title: "Alerta",
      html: typeof mensagem == "string" ? mensagem : `${mensagem}`,
      icon: "warning",
      iconColor: "#ffae00",
      showCancelButton: false,
      confirmButtonColor: "var(--azul)",
      confirmButtonText: textConfirmButton || "OK",
    });
  } else if (tipo == "Alert3") {
    return await Slw.fire({
      title: "Alerta",
      html: typeof mensagem == "string" ? mensagem : `${mensagem}`,
      icon: "warning",
      iconColor: "#ffae00",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  } else if (tipo == "Info") {
    return await Slw.fire({
      title: titulo || "Informação",
      html: typeof mensagem == "string" ? mensagem : `${mensagem}`,
      icon: "info",
      showCancelButton: false,
      confirmButtonColor: "var(--azul)",
      confirmButtonText: textConfirmButton || "OK",
    });
  } else if (tipo == "Sucesso-popup") {
    return await Swal.fire({
      toast: true,
      position: posicao || "top",
      html: typeof mensagem == "string" ? mensagem : `${mensagem}`,
      icon: "success",
      width: width || "fit-content",
      iconColor: "#81D75f",
      showConfirmButton: false,
      timer: tempo || 2500,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  } else if (tipo == "Alert-popup") {
    return await Swal.fire({
      toast: true,
      position: posicao || "top",
      html: typeof mensagem == "string" ? mensagem : `${mensagem}`,
      icon: "info",
      width: "fit-content",
      iconColor: "#ffae00",
      showConfirmButton: false,
      timer: tempo || 2500,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  } else if (tipo == "Erro-popup") {
    return await Slw.fire({
      toast: true,
      position: posicao || "top",
      html: typeof mensagem == "string" ? mensagem : `${mensagem}`,
      icon: "error",
      width: "fit-content",
      iconColor: "#ff735c",
      showConfirmButton: false,
      timer: tempo || 2500,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Slw.stopTimer;
        toast.onmouseleave = Slw.resumeTimer;
      },
    });
  } else if (tipo == "Loading") {
    return await Swal.fire({
      title: titulo || "Aguarde!",
      html: typeof mensagem == "string" ? mensagem : `${mensagem}`,
      icon,
      showConfirmButton: false,
      allowOutsideClick: false, // Desabilita clique fora do modal
      allowEscapeKey: false, // Desabilita tecla ESC
      allowEnterKey: false, // Desabilita tecla Enter
      showCloseButton: false, // Remove o X de fechar (opcional)
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }
}

export function CloseAlert() {
  return Swal.close();
}
